import React from "react";
import { Sparkles } from "lucide-react";

/**
 * "Reviewed by Kaily" boutique-service signature — the closing brand block
 * that lives at the bottom of every delivered kit. Distinguishes the
 * boutique studio from auto-generated AI output: every card was hand-read.
 *
 * Named ChannelBlock because it reinforces the slowcafe.kaily channel /
 * byline at the moment the customer finishes consuming the kit.
 */
export const ChannelBlock = ({ cafe }) => (
    <section className="mb-12 print:break-inside-avoid" data-testid="kit-channel-block">
        <div className="border-y-2 border-double border-cafe-olive/30 py-8 sm:py-10 px-6 text-center bg-cafe-latte/40 rounded-2xl">
            <p className="text-[10px] uppercase tracking-[0.3em] text-cafe-olive mb-2">Boutique service</p>
            <p className="font-display italic text-3xl sm:text-4xl text-cafe-espresso mb-3">
                Reviewed by Kaily
            </p>
            <p className="text-cafe-mocha text-sm max-w-md mx-auto leading-relaxed">
                Every card above was personally read line-by-line and refined before it left my desk. If anything doesn't sound like <em>{cafe}</em>, reply to your delivery email — I'll rewrite it.
            </p>
            <div className="mt-5 inline-flex items-center gap-2 text-[10px] uppercase tracking-[0.25em] text-cafe-olive font-semibold border border-cafe-olive/30 rounded-full px-4 py-1.5">
                <Sparkles className="w-3 h-3" /> Hand-checked · Kaily F&B Visual Studio
            </div>
        </div>
    </section>
);
